module.exports = __webpack_public_path__ + "img/84.e75dbea1.jpg";